import Layout from "../../../components/layout/layout.js";
import KeyPlayerContactsDirectoryPhoneCleanup from "../../../components/componentsPage/keyPlayerContactsDirectoryPhoneCleanup/index.js";

function KeyPlayerContactsDirectoryPhoneCleanupPage({ component, ...rest }) {
  return <Layout Component={KeyPlayerContactsDirectoryPhoneCleanup} controlsDisabled={true} {...rest} />;
}

export default KeyPlayerContactsDirectoryPhoneCleanupPage;
